import * as types from './mutation-types'
export const changeTheme = ({ commit }, themeValue) => commit(types.CHANGE_THEME, themeValue)

export const updateMenus = ({ commit }, menus) => commit(types.UPDATE_MENUS, menus)

export const updateToken = ({ commit }, token) => commit(types.UPDATE_TOKEN, token)

export const updateUserInfo = ({ commit }, userInfo) => commit(types.UPDATE_USERINFO, userInfo)
